import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { components } from 'cng-web-lib'
import NBCIUSCAPartyMasterApiUrls from '../../../apiUrls/NBCIUSCAPartyMasterApiUrls'
import pathMap from '../../../paths/pathMap'
import FormProperties from './FormProperties'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import { Box, Card, Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

const {
  button: { CngButton },
  form: { CngEditForm }
} = components

function EditPage(props) {
  const { history, onSetLoading, showNotification } = props
  const { id } = useParams()

  return (
    <Card>
      <Box padding={2}>
        <CngEditForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{ url: NBCIUSCAPartyMasterApiUrls.GET }}
          update={{ url: NBCIUSCAPartyMasterApiUrls.PUT }}
          id={id}
          renderButtonSection={(loading) => (
            <ButtonSection
              loading={loading}
              onDiscard={() => history.push(pathMap.NBCI_USCA_PARTY_MASTER_LIST_VIEW)}
              onSetLoading={onSetLoading}
            />
          )}
        />
      </Box>
    </Card>
  )
}

function ButtonSection(props) {
  const { loading, onDiscard, onSetLoading } = props
  const [alertDialog, setAlertDialog] = useState(false)
  const {
    formState: { isSubmitting }
  } = useFormContext()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={isSubmitting}
            onClick={() => setAlertDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton disabled={isSubmitting} type='submit' size='medium'>
            Save
          </CngButton>
        </Grid>
      </Grid>
      <AlertDialog
        cancelLabel='Continue editing'
        confirmLabel='Yes, discard'
        open={alertDialog}
        onClose={() => setAlertDialog(false)}
        onCancel={() => setAlertDialog(false)}
        onConfirm={onDiscard}
        title='Discard'
      >
        All progress in this session will be lost and can't be restored. Are you
        sure about this?
      </AlertDialog>
    </>
  )
}

export default withFormState(EditPage)
